export default {
    general: {
        required: '',
        email: '',
        phoneNumber: '',
        errorOccurred: '',
        maxLength: '',
        minLength: '',
        range: '',
        integer: '',
        numeric: '',
        length: '',
        id: '',
        name: '',
        max: '',
        min: '',
        mustContainDigits: '',
        mustContainLowercaseCharacters: '',
        mustContainUppercaseCharacters: '',
    },

    password: {
        length: '',
        noMatch: '',
    },

    dateTime: {
        periodNegative: '',
        maxDays: ''
    },

    more: {
        someOfTheFieldsContainErrors: '',
        generalError: ''
    },

    login: {
        credentialsError: ''
    }

};
